import React from 'react';
import loadable from '@loadable/component';

export const AsyncContactUsLayout = loadable(() => import(/* webpackPrefetch: true */ './ContactUsLayout'));

const ContactUs = (props) => <AsyncContactUsLayout {...props} />;

export default ContactUs;
